import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' }) // We want this to be a singleton service, so it needs providedIn: 'root'
export class ResizableSidePanelService {

  readonly isResizing = signal(false);
  readonly dragHandleEnabled = signal(false);
  #noHoverCapacity = signal(window.matchMedia('(any-hover: none)').matches);

  readonly dragHandleVisible = computed(() => this.isResizing() || this.dragHandleEnabled() || this.#noHoverCapacity());

  initialize(): void {
    this.isResizing.set(false);
    this.dragHandleEnabled.set(false);
  }

}
